/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState } from 'react';

import Select from 'react-select';
import { Collapse } from 'react-collapse';
import { shape, func, bool, string, arrayOf, number } from 'prop-types';

import SellerFeeStructure from './SellerFeeStructure';
import VendorFeeStructure from './VendorFeeStructure';
import CombinedRevShare from '../StatementOfWork/CombinedRevShare';
import { CurrencyIcon } from '../../../../theme/images';

import {
  accountTypeOptions,
  channelsWithSection,
  feeStructureContainerDetails,
  HYBRID,
  newAccountTypeOptions,
  SELLER_ACCOUNT_TYPES,
  VENDOR_ACCOUNT_TYPES,
} from '../../../../constants';
import {
  Button,
  CheckBox,
  ContractInputSelect,
  ErrorMsg,
  InputFormField,
} from '../../../../common';

export default function FeeStructureContainer({
  formData,
  setFormData,
  executeScroll,
  setOpenCollapse,
  openCollapse,
  renderCollapseBtnErrorHtml,
  loader,
  nextStep,
  DropdownIndicator,
  marketPlacesOptions,
  setUpdatedFormData,
  updatedFormData,
  setAdditionalMarketplaces,
  showFooter,
  sectionError,
  setSectionError,
  feeStructureErrors,
  setFeeStructureErrors,
  getMonthlyServices,
  showRightTick,
  getFeeStructureDetails,
  manageErrorCount,
  selectedCurrency,
  disableCombineRevShare,
  contractAddendumDetails,
  checkAddendumData,
  addendumDetails,
  displayMarketplaceName,
  channelServices,
  originalData,
}) {
  const selectedChannelServices =
    (contractAddendumDetails?.notActive
      ? addendumDetails?.channel_services
      : originalData?.channel_services) || [];
  const vendorField = formData?.fee_structure_vendor_type;
  const sellerField = formData?.fee_structure_seller_type;

  const [vendorSameAsSeller, setVendorSameAsSeller] = useState(
    formData?.fee_structure?.[vendorField]?.vendor_same_as_seller || false,
  );
  const [combinedRevShareFlag, setCombinedRevShareFlag] = useState(false);
  const clearError = (event, key) => {
    if (event && event.value) {
      if (
        (key === 'seller_type' && !(formData && formData[key]?.value)) ||
        !(formData && formData[key])
      ) {
        setSectionError({
          ...sectionError,
          feeStructure: sectionError.feeStructure
            ? sectionError.feeStructure - 1
            : 0,
        });
      }
    }
  };

  // Clear channel_services error when at least one service is selected
  const clearChannelServicesError = (isChecked) => {
    // If checking and currently no services selected, clear the error
    if (
      isChecked &&
      (!formData?.channel_services || formData.channel_services.length === 0)
    ) {
      setSectionError({
        ...sectionError,
        feeStructure: sectionError.feeStructure
          ? sectionError.feeStructure - 1
          : 0,
      });
    }
    // If unchecking and only one service was selected, add the error back
    if (!isChecked && formData?.channel_services?.length === 1) {
      setSectionError({
        ...sectionError,
        feeStructure: (sectionError.feeStructure || 0) + 1,
      });
    }
  };

  const handleChange = (event, key) => {
    showFooter(true);
    if (key === 'primary_marketplace') {
      setAdditionalMarketplaces(
        marketPlacesOptions.filter((op) => op.value !== event.value),
      );
      setFormData({ ...formData, [key]: event?.value });
      setUpdatedFormData({
        ...updatedFormData,
        [key]: event?.value,
      });
    } else if (key === 'combined_rev_share') {
      setFormData({ ...formData, combined_rev_share: event.target.checked });
      setUpdatedFormData({
        ...updatedFormData,
        combined_rev_share: event.target.checked,
      });
      setCombinedRevShareFlag(event.target.checked);
      setFeeStructureErrors({});
    } else if (key === 'seller_type') {
      if (
        formData?.fee_structure?.[vendorField]?.vendor_same_as_seller &&
        formData.seller_type?.value !== HYBRID &&
        event.value !== HYBRID
      )
        setVendorSameAsSeller(false);

      setFormData({
        ...formData,
        seller_type: { value: event?.value, label: event?.label },
        vendor_same_as_seller: false,
      });
      getFeeStructureDetails(event.value, {
        ...formData,
        seller_type: { value: event?.value, label: event?.label },
        vendor_same_as_seller: false,
      });
      setUpdatedFormData({
        ...updatedFormData,
        seller_type: event?.value,
      });
      setFeeStructureErrors({});
      getMonthlyServices(
        event?.value,
        formData?.channel?.value,
        formData?.isNewChannel,
      );
    } else {
      setFormData({ ...formData, [key]: event?.value });
      setUpdatedFormData({
        ...updatedFormData,
        [key]: event?.value,
      });
    }
    clearError(event, key);
  };

  const generateDropdown = (item) => {
    return (
      <Select
        classNamePrefix={
          (!(formData && formData[item.key]) && item.isMandatory) ||
          (item.key === 'seller_type' &&
            !(formData && formData[item.key]?.value) &&
            item.isMandatory)
            ? 'react-select  form-control-error'
            : 'react-select'
        }
        styles={{
          control: (base, state) => ({
            ...base,
            background:
              (!(formData && formData[item.key]) && item.isMandatory) ||
              (item.key === 'seller_type' &&
                !(formData && formData[item.key]?.value) &&
                item.isMandatory)
                ? '#FBF2F2'
                : '#F4F6FC',
            // match with the menu
            // borderRadius: state.isFocused ? '3px 3px 0 0' : 3,
            // Overwrittes the different states of border
            borderColor:
              (!(formData && formData[item.key]) && item.isMandatory) ||
              (item.key === 'seller_type' &&
                !(formData && formData[item.key]?.value) &&
                item.isMandatory)
                ? '#D63649'
                : '#D5D8E1',

            // Removes weird border around container
            boxShadow: state.isFocused ? null : null,
            '&:hover': {
              // Overwrittes the different states of border
              boxShadow: state.isFocused ? null : null,
              outlineColor: state.isFocused ? null : null,
            },
            option: (styles, { isDisabled }) => {
              return {
                ...styles,
                color: isDisabled ? '556178' : '556178',
              };
            },
          }),
        }}
        placeholder={item.placeholder || 'Select'}
        defaultValue={
          item.key === 'primary_marketplace'
            ? formData.primary_marketplace?.name
              ? {
                  value: formData.primary_marketplace.name,
                  label: displayMarketplaceName(
                    formData.primary_marketplace.name,
                    'primary',
                  ),
                }
              : formData?.primary_marketplace
              ? {
                  value: formData.primary_marketplace,
                  label: displayMarketplaceName(
                    formData.primary_marketplace,
                    'primary',
                  ),
                }
              : null
            : formData[item.key] && formData[item.key].label
            ? {
                value: formData[item.key].value,
                label: formData[item.key].label,
              }
            : null
        }
        options={
          item.key === 'primary_marketplace'
            ? marketPlacesOptions
            : formData?.isNewChannel
            ? newAccountTypeOptions
            : accountTypeOptions
        }
        name={item.key}
        components={{ DropdownIndicator }}
        onChange={(event) => handleChange(event, item.key)}
        isDisabled={contractAddendumDetails.notActive}
      />
    );
  };
  const displayErrorCount = () => {
    if (SELLER_ACCOUNT_TYPES.includes(formData?.seller_type?.value)) {
      return sectionError.feeStructure + sectionError?.[sellerField]?.feeType;
    }
    if (VENDOR_ACCOUNT_TYPES.includes(formData?.seller_type?.value)) {
      return sectionError.feeStructure + sectionError?.[vendorField]?.feeType;
    }
    if (formData?.seller_type?.value === HYBRID) {
      return (
        sectionError.feeStructure +
        sectionError?.[sellerField]?.feeType +
        sectionError?.[vendorField]?.feeType
      );
    }
    return sectionError.feeStructure;
  };

  const handleChannelChange = (event, selectedService) => {
    showFooter(true);
    clearChannelServicesError(event.target.checked);
    let showServiceInTable = [];
    if (formData?.channel_services?.length)
      showServiceInTable = [...formData?.channel_services];

    if (!event.target.checked) {
      // add the selected service in the delete array and remove the service from the agreement table (on LHS).
      let tempDeletedServices = [];
      if (updatedFormData?.channel_services?.delete) {
        tempDeletedServices = [...updatedFormData.channel_services?.delete];
      }

      // Always remove from formData
      showServiceInTable = formData?.channel_services?.filter(
        (op) => op.name !== event.target.name,
      );

      let createServices = updatedFormData?.channel_services?.create?.length
        ? [...updatedFormData?.channel_services?.create]
        : [];
      createServices = updatedFormData?.channel_services?.create?.filter(
        (op) => op.name !== event.target.name,
      );

      setFormData({
        ...formData,
        channel_services: showServiceInTable,
      });

      // Only add to delete array if the service has an ID AND is not already in delete array
      const isAlreadyInDeleteArray = tempDeletedServices?.includes(
        selectedService?.id,
      );

      if (selectedService?.id && !isAlreadyInDeleteArray) {
        setUpdatedFormData({
          ...updatedFormData,
          channel_services: {
            create: createServices,
            delete: [...tempDeletedServices, selectedService?.id],
          },
        });
      } else {
        setUpdatedFormData({
          ...updatedFormData,
          channel_services: {
            create: createServices,
            delete: tempDeletedServices,
          },
        });
      }
    }
    if (event.target.checked) {
      let tempCreateServices = [];
      if (updatedFormData?.channel_services?.create) {
        tempCreateServices = [...updatedFormData.channel_services?.create];
      }

      // if selected service not in DB, add it in create array and show the service in agreement table (on LHS).
      if (!selectedService?.id) {
        const addendumData = {
          name: event.target.name,
          contract_addendum: formData?.id,
        };
        const contractData = {
          name: event.target.name,
          contract: formData?.id,
        };
        showServiceInTable.push(
          contractAddendumDetails?.notActive ? addendumData : contractData,
        );

        setFormData({
          ...formData,
          channel_services: showServiceInTable,
        });
        const createContractData = contractAddendumDetails?.notActive
          ? {
              name: event.target.name,
              contract_addendum: formData?.id,
            }
          : { name: event.target.name, contract: formData?.id };
        setUpdatedFormData({
          ...updatedFormData,
          channel_services: {
            ...updatedFormData.channel_services,
            create: [...tempCreateServices, createContractData],
          },
        });
      }
      // if selected service in DB, remove the selected ID from the delete array and from the agreement table (on LHS).
      if (selectedService?.id) {
        const contractData = {
          name: event?.target?.name,
          contract: formData?.id,
        };
        const addendumData = {
          name: event?.target?.name,
          contract_addendum: formData?.id,
        };
        showServiceInTable.push(
          contractAddendumDetails?.notActive ? addendumData : contractData,
        );
        setFormData({
          ...formData,
          channel_services: showServiceInTable,
        });
        const tempDeletedServices =
          updatedFormData.channel_services?.delete?.filter(
            (op) => op !== selectedService?.id,
          );
        setUpdatedFormData({
          ...updatedFormData,
          channel_services: {
            ...updatedFormData.channel_services,
            delete: tempDeletedServices,
          },
        });
      }
    }
  };

  const showCombineRevShareBox = () => {
    return (
      <CheckBox>
        <label
          className={
            disableCombineRevShare
              ? 'isDisabled check-container checkboxes-std-services customer-pannel'
              : 'check-container checkboxes-std-services customer-pannel'
          }
          htmlFor="combineRevShare"
        >
          Calculate the Rev Share by combining the {sellerField} Account Sales &{' '}
          {vendorField} Account Sales
          <input
            type="checkbox"
            name="combineRevShare"
            id="combineRevShare"
            onChange={(event) => handleChange(event, 'combined_rev_share')}
            checked={formData?.combined_rev_share || false}
            disabled={disableCombineRevShare}
          />
          <span className="checkmark" />
        </label>
      </CheckBox>
    );
  };

  return (
    <>
      <div className="straight-line horizontal-line  " />
      <div
        className="collapse-btn "
        role="presentation"
        type="button"
        onClick={() => {
          if (contractAddendumDetails?.notActive)
            executeScroll('draft-addendum');
          else executeScroll('statement');
          setOpenCollapse({
            feeStructure: !openCollapse.feeStructure,
          });
        }}
      >
        <img className="service-agre" src={CurrencyIcon} alt="pdf" />
        <h4
          className={
            displayErrorCount()
              ? 'sendar-details error-container'
              : 'sendar-details '
          }
        >
          Fee Structure
          {renderCollapseBtnErrorHtml(
            false,
            displayErrorCount(),
            openCollapse.feeStructure,
            'feeStructure',
          )}
        </h4>
        <div className="clear-fix" />
      </div>
      <Collapse isOpened={openCollapse.feeStructure}>
        {loader ? null : (
          <ul className="collapse-inner">
            <li>
              {feeStructureContainerDetails?.map((item) => (
                <ContractInputSelect
                  className={item.key !== 'primary_marketplace' ? 'mt-3' : ''}
                  key={item.key}
                >
                  <label htmlFor={item.key}>{item.label}</label>
                  {generateDropdown(item)}
                </ContractInputSelect>
              ))}
            </li>
            {channelsWithSection.includes(formData?.channel?.value) && (
              <li>
                <div className="mb-4">
                  <InputFormField className="mb-3">
                    <label htmlFor="channel_services">Channel Services</label>
                  </InputFormField>
                  {channelServices.length > 0 &&
                    channelServices?.map((serviceData) => (
                      <CheckBox key={serviceData?.value}>
                        <label
                          className="check-container checkboxes-std-services customer-pannel"
                          htmlFor={serviceData?.value}
                        >
                          {serviceData?.label}
                          <input
                            type="checkbox"
                            name={serviceData?.label}
                            id={serviceData?.value}
                            onClick={(event) =>
                              handleChannelChange(
                                event,
                                selectedChannelServices?.length &&
                                  selectedChannelServices?.find(
                                    (item) => item?.name === serviceData?.label,
                                  ),
                              )
                            }
                            defaultChecked={
                              formData?.channel_services?.length &&
                              formData.channel_services.find(
                                (item) => item?.name === serviceData?.label,
                              )
                            }
                          />
                          <span className="checkmark" />
                        </label>
                      </CheckBox>
                    ))}
                  {!formData?.channel_services?.length && (
                    <ErrorMsg>At least 1 channel service required</ErrorMsg>
                  )}
                </div>
              </li>
            )}

            <li>
              {SELLER_ACCOUNT_TYPES.includes(formData?.seller_type?.value) ? (
                <SellerFeeStructure
                  setFormData={setFormData}
                  updatedFormData={updatedFormData}
                  setUpdatedFormData={setUpdatedFormData}
                  formData={formData}
                  DropdownIndicator={DropdownIndicator}
                  section={sellerField}
                  showFooter={showFooter}
                  setSectionError={setSectionError}
                  sectionError={sectionError}
                  feeStructureErrors={feeStructureErrors}
                  setFeeStructureErrors={setFeeStructureErrors}
                  vendorSameAsSeller={vendorSameAsSeller}
                  selectedCurrency={selectedCurrency}
                  combinedRevShareFlag={combinedRevShareFlag}
                  contractAddendumDetails={contractAddendumDetails}
                  checkAddendumData={checkAddendumData}
                  addendumDetails={addendumDetails}
                />
              ) : VENDOR_ACCOUNT_TYPES.includes(
                  formData?.seller_type?.value,
                ) ? (
                <VendorFeeStructure
                  setFormData={setFormData}
                  updatedFormData={updatedFormData}
                  setUpdatedFormData={setUpdatedFormData}
                  formData={formData}
                  DropdownIndicator={DropdownIndicator}
                  section={vendorField}
                  showFooter={showFooter}
                  setSectionError={setSectionError}
                  sectionError={sectionError}
                  feeStructureErrors={feeStructureErrors}
                  setFeeStructureErrors={setFeeStructureErrors}
                  vendorSameAsSeller={vendorSameAsSeller}
                  setVendorSameAsSeller={setVendorSameAsSeller}
                  manageErrorCount={manageErrorCount}
                  selectedCurrency={selectedCurrency}
                  contractAddendumDetails={contractAddendumDetails}
                  checkAddendumData={checkAddendumData}
                  addendumDetails={addendumDetails}
                />
              ) : formData?.seller_type?.value === HYBRID ? (
                <>
                  {formData?.seller_type?.value === HYBRID ? (
                    <>{showCombineRevShareBox()}</>
                  ) : null}

                  <SellerFeeStructure
                    setFormData={setFormData}
                    updatedFormData={updatedFormData}
                    setUpdatedFormData={setUpdatedFormData}
                    formData={formData}
                    DropdownIndicator={DropdownIndicator}
                    section={sellerField}
                    showFooter={showFooter}
                    setSectionError={setSectionError}
                    sectionError={sectionError}
                    feeStructureErrors={feeStructureErrors}
                    setFeeStructureErrors={setFeeStructureErrors}
                    vendorSameAsSeller={vendorSameAsSeller}
                    selectedCurrency={selectedCurrency}
                    combinedRevShareFlag={combinedRevShareFlag}
                    contractAddendumDetails={contractAddendumDetails}
                    checkAddendumData={checkAddendumData}
                    addendumDetails={addendumDetails}
                  />
                  <VendorFeeStructure
                    setFormData={setFormData}
                    updatedFormData={updatedFormData}
                    setUpdatedFormData={setUpdatedFormData}
                    formData={formData}
                    DropdownIndicator={DropdownIndicator}
                    section={vendorField}
                    showFooter={showFooter}
                    setSectionError={setSectionError}
                    sectionError={sectionError}
                    feeStructureErrors={feeStructureErrors}
                    setFeeStructureErrors={setFeeStructureErrors}
                    vendorSameAsSeller={vendorSameAsSeller}
                    setVendorSameAsSeller={setVendorSameAsSeller}
                    manageErrorCount={manageErrorCount}
                    selectedCurrency={selectedCurrency}
                    contractAddendumDetails={contractAddendumDetails}
                    checkAddendumData={checkAddendumData}
                    addendumDetails={addendumDetails}
                  />
                  {formData?.combined_rev_share ? (
                    <CombinedRevShare
                      setFormData={setFormData}
                      updatedFormData={updatedFormData}
                      setUpdatedFormData={setUpdatedFormData}
                      formData={formData}
                      DropdownIndicator={DropdownIndicator}
                      showFooter={showFooter}
                      setSectionError={setSectionError}
                      sectionError={sectionError}
                      feeStructureErrors={feeStructureErrors}
                      setFeeStructureErrors={setFeeStructureErrors}
                      vendorSameAsSeller={vendorSameAsSeller}
                      setVendorSameAsSeller={setVendorSameAsSeller}
                      manageErrorCount={manageErrorCount}
                      selectedCurrency={selectedCurrency}
                      section={sellerField}
                      contractAddendumDetails={contractAddendumDetails}
                      checkAddendumData={checkAddendumData}
                    />
                  ) : null}
                </>
              ) : null}
            </li>

            <li>
              <Button
                className="btn-primary sidepanel btn-next-section mt-2 mb-3 w-100"
                disabled={!showRightTick('feeStructure')}
                onClick={() => nextStep('statement')}
              >
                Proceed to Next Section
              </Button>
            </li>
          </ul>
        )}
      </Collapse>
    </>
  );
}

FeeStructureContainer.defaultProps = {
  setOpenCollapse: () => {},
  executeScroll: () => {},
  nextStep: () => {},
  renderCollapseBtnErrorHtml: () => {},
  setUpdatedFormData: () => {},
  setFormData: () => {},
  setAdditionalMarketplaces: () => {},
  formData: {},
  updatedFormData: {},
  openCollapse: {},
  DropdownIndicator: {},
  marketPlacesOptions: {},
  loader: false,
  showFooter: () => {},
  sectionError: {},
  setSectionError: () => {},
  feeStructureErrors: {},
  setFeeStructureErrors: () => {},
  getMonthlyServices: () => {},
  showRightTick: () => {},
  getFeeStructureDetails: () => {},
  manageErrorCount: () => {},
  selectedCurrency: '$ (USD)',
  disableCombineRevShare: false,
  contractAddendumDetails: {},
  checkAddendumData: false,
  addendumDetails: {},
  channelServices: [],
  displayMarketplaceName: () => {},
  originalData: {},
};

FeeStructureContainer.propTypes = {
  executeScroll: func,
  setOpenCollapse: func,
  nextStep: func,
  renderCollapseBtnErrorHtml: func,
  formData: shape({
    seller_type: shape({}),
    fee_type: string,
  }),
  openCollapse: shape({
    feeStructure: bool,
  }),
  loader: bool,
  showFooter: func,
  DropdownIndicator: func,
  setUpdatedFormData: func,
  setFormData: func,
  updatedFormData: shape({}),
  marketPlacesOptions: arrayOf(shape({})),
  setAdditionalMarketplaces: func,
  originalData: shape({}),
  sectionError: shape({
    feeStructure: number,
  }),
  setSectionError: func,
  feeStructureErrors: shape({}),
  setFeeStructureErrors: func,
  getMonthlyServices: func,
  showRightTick: func,
  getFeeStructureDetails: func,
  manageErrorCount: func,
  selectedCurrency: string,
  disableCombineRevShare: bool,
  contractAddendumDetails: shape({}),
  checkAddendumData: bool,
  addendumDetails: shape({}),
  displayMarketplaceName: func,
  channelServices: arrayOf(shape({})),
};
